<template>
  <div class="m-activity-addPrizes">
    <div class="title">奖品配置</div>
    <div class="title-remark" v-if="activityType == 'Roulette'">（转盘分为{{prizesNumMax}}份，奖品最多可设置{{prizesNumMax}}份，最少设置1份；已设置的奖品将自动填充空余转盘位置）</div>
    <div class="title-remark" v-else-if="activityType == 'Lottery'">（奖品最多可设置{{prizesNumMax}}份，最少设置1份）</div>
    <auth-button auth="market:activity:update">
      <el-button v-if="isCanEdit" class="add-prize-btn" type="primary" @click="onAddPrize" >+ 添加奖品</el-button>
    </auth-button>

    <el-tabs v-if="prizesListData.length" v-model="tabsKey" type="card" :closable="isCanEdit" @tab-remove="onDelPrize" :before-leave="onTabClick" :key="tabsKeyValue">
      <el-tab-pane
        v-for="(prizesItem, prizesIndex) in prizesListData"
        :label="`奖品` + (prizesIndex + 1)"
        :key="prizesIndex"
        :name="`${prizesIndex}`"
      >
        <PrizesForm
          :baseInfo="baseInfo"
          :sumProbability="sumProbability"
          :prizesItem="prizesItem"
          :prizesIndex="prizesIndex"
          :tabsKey="tabsKey"
          :isCanEdit="isCanEdit"
          :mallData="mallData"
          :couponListData_Coupon="couponListData_Coupon"
          :couponListData_GiftCoupon="couponListData_GiftCoupon"
          :couponListData_LotCoupon="couponListData_LotCoupon"
          :couponListData_SkuCoupon="couponListData_SkuCoupon"
          @onIsEdit="onIsEdit"
          @getPrizeData="getPrizeData"
          @delPrizeOk="delPrizeOk"
        ></PrizesForm>
      </el-tab-pane>
    </el-tabs>
    <div v-else>暂无奖品</div>

  </div>
</template>

<script>
import { getStorage } from '@/utils/index'
import AuthButton from '@/components/AuthButton'
import { api_getPrizesData, api_postPrizeDel } from '@/api/market'
import { api_getListCoupon, api_getGiftListCoupon, api_getSkuCouponList } from '@/api/common'
import { api_getParkingCouponTemplate } from '@/api/parking'
import PrizesForm from './prizesForm.vue'

export default {
  name: "marketActivityListAddPrizes",
  components: {
    AuthButton,
    PrizesForm,
  },
  props: {
    baseInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    isCanEdit: {
      type: Boolean,
      default() {
        return true
      }
    },
    mallData: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      prizesNumMax: 7, // 奖品可配置数量
      activityType: '', // 奖品类型
      submitLoading: false, // 确定按钮加载loading
      tabsKeyValue: false, // tabs组件key
      tabsKey: '0', // tabs绑定key
      isCanChangeTabs: false, // 是否可以添加、切换tab
      sumProbability: 0, // 当前所有奖品的中奖概率
      prizesListData: [
        {
          isEdit: true
        }
      ], // 奖品list数据
      couponListData_Coupon: null,
      couponListData_GiftCoupon: null,
      couponListData_LotCoupon: null,
      couponListData_SkuCoupon: null,
    };
  },
  async created() {
    this.activityType = this.$route.query.type
    this.setPrizeNumMax() // 设置奖品最大可配置数量
    if (this.$route.query.id) {
      this.getPrizeData() // 获取奖品数据
    }
    this.getCouponListData() // 获取优惠券列表数据
    this.getGiftCouponListData() // 获取礼品券列表数据
    this.getLotCouponListData() // 获取停车券列表数据
    this.getSkuCouponListData() // 获取抵扣券列表数据
  },
  methods: {
    // 获取奖品数据
    async getPrizeData() {
      this.sumProbability = 0
      const { id, page } = this.$route.query
      const res = await api_getPrizesData({activityId: id})
      console.log('奖品res: ', res);
      this.prizesListData = res
      this.tabsKeyValue = !this.tabsKeyValue

      if (!res.length && page != 'detail') {
        this.prizesListData = [{isEdit: true}]
      } else {
        // 计算已存在奖品的中奖概率之和
        this.prizesListData.forEach(item => {
          this.sumProbability = this.sumProbability + item.probability
        })
        this.isCanChangeTabs = true
      }
    },

    // 设置奖品最大可配置数量
    setPrizeNumMax() {
      if (getStorage('USER_PERMISSIONS').indexOf('/market/welfareCouponList') > -1) {
        this.prizesNumMax = 8 // 万益通租户最多可配置8个奖品
      }
    },

    // 获取优惠券列表数据
    async getCouponListData() {
      const res = await api_getListCoupon()
      this.couponListData_Coupon = res || []
    },

    // 获取礼品券列表数据
    async getGiftCouponListData() {
      const res = await api_getGiftListCoupon()
      this.couponListData_GiftCoupon = res || []
    },

    // 获取停车券列表数据
    async getLotCouponListData() {
      const res = await api_getParkingCouponTemplate()
      this.couponListData_LotCoupon = res || []
    },

    // 获取抵扣券列表数据
    async getSkuCouponListData() {
      const res = await api_getSkuCouponList()
      this.couponListData_SkuCoupon = res || []
    },

    // 点击切换tab（切换tab之前触发）
    onTabClick(newKey, oldKey) {
      if (!this.isCanChangeTabs) {
        this.$baseMessage('请先保存当前奖品信息', 'warning')
        return false
      }
      if (this.prizesListData[this.tabsKey] && this.prizesListData[this.tabsKey].isEdit || !this.prizesListData[this.tabsKey]) {
        this.isCanChangeTabs = false
      }
      this.tabsKey = newKey
    },

    // 改变当前是否可以切换tab的状态
    onIsEdit(status) {
      this.prizesListData[this.tabsKey].isEdit = status
      this.tabsKeyValue = !this.tabsKeyValue // 重新渲染
      this.isCanChangeTabs = !status
    },

    // 点击添加奖品
    onAddPrize() {
      if (!this.isCanChangeTabs) {
        this.$baseMessage('请先保存当前奖品信息', 'warning')
      } else if (this.activityType == 'Roulette' && this.prizesListData.length >= this.prizesNumMax) {
        this.$baseMessage(`奖品数量最多可设置${this.prizesNumMax}份`, 'warning')
      } else if (this.activityType == 'Lottery' && this.prizesListData.length >= this.prizesNumMax) {
        this.$baseMessage(`奖品数量最多可设置${this.prizesNumMax}份`, 'warning')
      } else {
        this.prizesListData.push({isEdit: true})
        this.onTabClick(this.prizesListData.length - 1 + '')
      }
    },

    // 点击删除奖品
    onDelPrize(targetName) {
      this.$baseConfirm(
        `是否删除该奖品？`,
        {title: '提示', type: 'warning',},
        async () => {
          if (this.prizesListData[targetName].id) {
            await api_postPrizeDel({id: this.prizesListData[targetName].id})
          }
          this.delPrizeOk(targetName)
        })
    },

    // 确认删除
    delPrizeOk(targetName) {
      if (this.tabsKey == this.prizesListData.length - 1) {
        this.tabsKey = `${this.prizesListData.length - 2}`
      }
      this.getPrizeData()
      this.isCanChangeTabs = true
    },

  },
};
</script>

<style lang="scss" scoped>
.m-activity-addPrizes {
  width: 100%;
  margin-top: 50px;
  box-sizing: border-box;
  position: relative;

  .add-prize-btn {
    margin-bottom: 20px;
  }

  // 奖品设置
  .prizes-box {

    .prizes-list-box {

      .prizes-item {
        .item-form-box {
          margin-top: 20px;
        }
      }
    }

    .add-btn {
      margin-left: 80px;
    }

  }

  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }


  .title {
    margin: 0;
    margin-bottom: 10px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }
  }

  .title-remark {
    color: #666666;
    font-size: 14px;
    margin-bottom: 20px;
  }

  .footer{
    text-align: right;
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
    right: 0;
    z-index: 999;

    .mr100 {
      margin-right: 100px;
    }
  }
}
</style>
